module.exports = __webpack_public_path__ + "media/img/sbt-test/amex-f3744300d8d6585655f593095ea47125.svg";